const translations = {
  "en": {
    "Free Alpha Signals": "Free Alpha Signals",
    "Log in/ Sign up": "Log in/ Sign up"
  },
  "zh-tw": {
    "Free Alpha Signals": "免費 Alpha 訊號",
    "Log in/ Sign up": "登入/ 註冊"
  }
};

export default translations;
